import React, { useCallback } from 'react'
import { Collapse, FormControl, FormHelperText } from '@mui/material'
import { secondaryText } from '@/constant'
import { MessageChannelEnum } from '@/types'
import { GrayCard, Row } from './components'
import TagInput from '@/components/TagInput'
import Text from '@/components/Text'
import Test from './testChannel'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
export interface SysFormProps {
  id?: string;
  value: string[];
  onChange: (value: string[]) => void;
  max?: number;
  validate: boolean;
  expand: boolean;
  onExpand: (expand: boolean) => void;
}

const SysForm: React.FC<SysFormProps> = (props) => {
  const { id, value, onChange, max, validate, expand, onExpand } = props
  console.log('SysFormProps', value)
  const handleClick = useCallback(() => {
    onExpand(!expand)
  }, [expand, onExpand])

  return (
    <GrayCard id={id} expand={expand ? 'true' : 'false'}>
      <Text
        weight="bold"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        syslog
        {expand ? (
          <RemoveCircleOutlineIcon
            sx={{ fontSize: '14px', color: secondaryText }}
          />
        ) : (
          <AddCircleOutlineIcon
            sx={{ fontSize: '14px', color: secondaryText }}
          />
        )}
      </Text>
      <Collapse in={expand} sx={{ padding: 0 }}>
        <FormControl sx={{ width: '100%', marginTop: '16px' }}>
          <TagInput
            label={'syslog'}
            required={true}
            tagVariant={'syslog'}
            size={max}
            value={value}
            onChange={onChange}
            placeholder="192.168.0.1:8888"
          />
          {/* {value?.length === max && !validate && (
            <FormHelperText sx={{ marginLeft: "0px" }} error={true}>
              请限制邮件接收人数在10位以内
            </FormHelperText>
          )} */}
          {validate && value?.length === 0 && (
            <FormHelperText sx={{ marginLeft: '0px' }} error={true}>
              请输入 syslog
            </FormHelperText>
          )}
        </FormControl>
        <Row>
          <Test
            type={MessageChannelEnum.syslog}
            contents={value?.map((item) => ({ address: item, sign: '' })) ?? []}
          />
        </Row>
      </Collapse>
    </GrayCard>
  )
}

export default SysForm
